import { UseToastOptions, useToast } from '@chakra-ui/react';

const TOAST_DEFAULT_PROPS: UseToastOptions = {
  isClosable: true,
  position: 'top'
};

type Props = {
  success?: string,
  error?: string
}

export const useMessages = ({ success = 'Deu tudo certo!', error = 'Houve um problema. Tente novamente mais tarde.' }: Props = {}) => {
  const toast = useToast();

  const onSuccess = () => toast({
    ...TOAST_DEFAULT_PROPS,
    title: success,
    status: 'success'
  });

  const onError = (newError?: string) => toast({
    ...TOAST_DEFAULT_PROPS,
    title: newError || error,
    status: 'error',
  });

  return { onSuccess, onError };

}